import { lazy, useEffect, useState, type ReactNode } from "react";
import { subscribeSession } from "../shared/api";
import {
  goToProductPicker,
  isProductSwitchEnabled,
  rememberProduct,
  resolveCurrentProductRoute
} from "./productSelection";

const ProductPicker = lazy(() => import("./ProductPicker").then((m) => ({ default: m.ProductPicker })));
const EntProductHost = lazy(() => import("./EntProductHost").then((m) => ({ default: m.EntProductHost })));

/**
 * Product-first login cho task pane. Bọc app COM mà không sửa code bên trong:
 * - chưa cấu hình `VITE_ENT_REMOTE_ENTRY` → render `children` như cũ;
 * - chưa đăng nhập → màn chọn; đã chọn / còn phiên → COM (`children`) hoặc ENT (Module Federation);
 * - phiên COM mất (đăng xuất, hết hạn) → về màn chọn. ENT tự về qua `signOutUrl`.
 */
export function ProductShell({ children }: { children: ReactNode }) {
  const [route] = useState(resolveCurrentProductRoute);
  const enabled = isProductSwitchEnabled();

  useEffect(() => {
    if (enabled && route.kind !== "picker") {
      rememberProduct(route.kind);
    }
  }, [enabled, route]);

  useEffect(() => {
    if (!enabled || route.kind !== "com") {
      return;
    }
    return subscribeSession((session) => {
      if (!session) {
        goToProductPicker();
      }
    });
  }, [enabled, route]);

  if (route.kind === "picker") {
    return <ProductPicker />;
  }
  if (route.kind === "ent") {
    return <EntProductHost requireSession={route.requireSession} />;
  }
  return <>{children}</>;
}
